var makePost=function(module, action, userdata, loader, cb) {
	var self=this;
	// var url =self.params.url;
	var auth={};
	if (self.params.session !=null) {
		if (typeof self.params.session.sessid !== "undefined" && self.params.session.sessid!=null) auth.session=self.params.session.sessid;
	}
	if (typeof userdata === "undefined" || userdata==null)  userdata={};
	if (navigator.onLine) {
		var xmlhttp = new XMLHttpRequest();
		xmlhttp.onreadystatechange = function () {
			if (xmlhttp.readyState == XMLHttpRequest.DONE) {   // XMLHttpRequest.DONE == 4
				if (xmlhttp.status == 200) {
					// console.log(xmlhttp.responseText)
					var respond = JSON.parse(xmlhttp.responseText);
					if (typeof loader !== "undefined" && loader != null) loader.hide();
					if (typeof cb !== "undefined" && cb != null) cb(respond);
				} else {
					if (cb) cb({status: 'ERROR'});
					console.error('ОШИБКИ AJAX запроса:');
				}
			}
		};
		xmlhttp.open("POST", self.params.url, true);
		var data = new FormData();
		data.append('json', JSON.stringify({
			auth: auth,
			// data: userdata,
			data: {params: userdata, user: self.params.session},
			module: module,
			cmd: action,
			key: self.params.key
		}));
		xmlhttp.send(data);
	} //else alert('Отсутствует подключение к Интернет');
};

export default makePost;
